import { ReplaceMapSanitized } from '../../interfaces/replaceMap';
import { ResidentType } from '../person/resident.data';
import { MsgQueueBase } from './messageQueue.data';

export interface NotificationQueueData extends MsgQueueBase<NotificationStatus> {
  /** @deprecated chat message still uses it, in other cases use bodyKey */
  body?: string | null;
  titleKey?: string;
  bodyKey?: string | null;
  deepLink: string;
  target: NotificationTarget;
  completedDate?: number;
  lastUpdate: number; // Date
  additionalData: NotificationAdditionalData;
}

export interface NotificationAdditionalData {
  type: NotificationType;
  /**
   * for RESOLUTION "$resolutionId|$newsId"
   * for MESSAGE "$conversationId|$messageId"
   */
  foreignId?: string;
  // ! if reminder, foreignId must exist
  reminder?: boolean;
  replaceMap?: ReplaceMapSanitized | null;
}

/**
 * One of this fields must contain data
 */
export interface NotificationTarget {
  sendToAll?: boolean | null;
  userIds?: string[] | null;
  address?: TargetAddress[] | null;
  residentTypes?: ResidentType[] | null;
}

export interface TargetAddress {
  block: string;
  stairway?: string | null;
  number?: string | null;
}

export enum NotificationStatus {
  PENDING = 'PENDING',
  PROCESSED = 'PROCESSED',
  COMPLETE = 'COMPLETE',
  COMPLETE_NOT_SEND = 'COMPLETE_NOT_SEND',
  CANCELED = 'CANCELED',
  FAILED = 'FAILED'
}

export enum NotificationType {
  BOOKING = 'booking',
  CONTACT = 'contact',
  DEFECT = 'defect',
  DOCUMENT = 'documents',
  MESSAGE = 'messages',
  NEWS = 'news',
  OFFER = 'offers',
  PAYMENT = 'payment',
  PARKING = 'parking',
  POLL = 'poll',
  RESOLUTION = 'resolution',
  PARK_CASH_ENTRY = 'parkCashEntry'
}

export interface NotificationSubscription {
  booking: boolean;
  contact: boolean;
  defect: boolean;
  documents: boolean;
  messages: boolean;
  news: boolean;
  offers: boolean;
  parking: boolean;
  payment: boolean;
  poll: boolean;
  resolution: boolean;
}
